var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",class:_vm.$bus.fullscreenFlag ? 'home__fullscreen' : ''},[_c('home-map'),_c('home-team',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$bus.fullscreenFlag),expression:"!$bus.fullscreenFlag"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }